// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__G74o3","breadcrumbsItem":"breadcrumbs_breadcrumbsItem__UIwpR","isPrivateArea":"breadcrumbs_isPrivateArea__pGYTy"};